export enum WorkflowExecutionState {
    started = 'Started',
    completed = 'Completed',
    cancelled = 'Cancelled',
    pending = 'Pending',
    succeeded = "Succeeded",
    failed = "Failed",
    ignored = 'Ignored',
    unknown = 'Unknown'
}
